import { relations } from 'drizzle-orm';
import { boolean, pgEnum, pgTable, text, timestamp } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { licence } from './licence.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
import { organisationUser } from './organisation-user.js';
export const OrganisationStatus = z.enum(['active', 'suspended']);
export const organisationStatusEnum = pgEnum('organisation_status', [
    OrganisationStatus.enum.active,
    OrganisationStatus.enum.suspended,
]);
export const OrganisationType = z.enum(['HOSPITAL', 'PRIVATE_PHARMACY']);
export const organisationTypeEnum = pgEnum('type', [
    OrganisationType.enum.HOSPITAL,
    OrganisationType.enum.PRIVATE_PHARMACY,
]);
export const organisation = pgTable('organisation', {
    id: uuidv7('id').primaryKey(),
    internalId: text('internal_id').notNull(),
    name: text('name').notNull(),
    country: text('country').notNull(),
    street: text('street'),
    status: organisationStatusEnum('status').default(OrganisationStatus.enum.active).notNull(),
    type: organisationTypeEnum('type').notNull(),
    isDemo: boolean('is_demo').notNull().default(false),
    lastActivityAt: timestamp('last_activity_at'),
    hmsUrl: text('hms_url'),
    // On-premise Cypro version reported via telemetry heartbeat (e.g. "v1.4.2").
    // Null for deployments that haven't sent a version-aware heartbeat yet.
    deployedVersion: text('deployed_version'),
    ...timestamps(),
    ...userActions(),
});
export const organisationRelations = relations(organisation, ({ many }) => ({
    licences: many(licence),
    users: many(organisationUser),
}));
//# sourceMappingURL=organisation.js.map